import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../../shared";
import { PersonSelectorService } from "../../../personselector/personselector.service";
import { ReportService } from "../../../Report/report.service";
import { DataService_Student_Point } from "../shared/data.service";
import { StudentPBISAddComponent } from "./student-pbis-add/student-pbis-add.component";
import { StudentPBISRedeemComponent } from "./student-pbis-redeem/student-pbis-redeem.component";
import * as moment from "moment";

@Component({
	selector: "caass-student-pbis-person-mode",
	templateUrl: "./student-pbisperson-mode.component.html",
	styleUrls: ["./student-pbisperson-mode.component.css"],
})
export class StudentPBISPersonModeComponent implements OnInit {
	constructor(
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private PBISService: DataService_Student_Point,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private reportService: ReportService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadStats();
			this.loadStudentPBISData();
			// this.onRefresh();
		});

		if (this.SelectedPerson != undefined) {
			this.loadStats();
			this.loadStudentPBISData();
		}
	}

	ngOnChanges() {
		if (this.SelectedPerson != undefined) {
			this.loadStats();
			this.loadStudentPBISData();
		}
	}

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	user: any;
	SelectedPerson: any;
	private subscriptionPersonSelect: Subscription;

	//Stats and Options
	StartDate: Date = new Date();
	EndDate: Date = new Date();
	ShowVoid: boolean = false;

	CurrentBalance: any = 0;

	ErrorMessage: any = "";

	StatLoading: any = true;
	isProcessing: any = false;

	//Table
	///////////////
	// Built-In
	///////////////

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPointsTransaction: any;
	lstPointsTransaction: any = [];

	//Filter lists
	lstPointsTransactionTypeDesc: any = [];
	lstPointsItemDesc: any = [];
	lstIsVoidDesc: any = [];
	lstPartOfGroupDesc: any = [];
	lstGroupName: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "TransactionDTDesc", header: "Date/Time" },
		{ field: "PointsTransactionTypeDesc", header: "Transaction Type" },
		{ field: "PointsItemDesc", header: "Point" },
		{ field: "PointsItemValue", header: "Point Value" },
		// { field: 'IsVoidDesc', header: 'Voided'}
	];

	///////////////

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	loadStats() {
		//Init Stats
		this.CurrentBalance = 0;
		this.StatLoading = true;

		var result = this.PBISService.PBISGetBalance(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.CurrentBalance = response[0];

				this.StatLoading = false;
			},
			(error) => {
				this.StatLoading = false;
			}
		);
	}

	loadStudentPBISData() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.PBISService.PBISPointSelectList(this.SelectedPerson.PersonID, fsDate, feDate, this.ShowVoid == true ? 1 : 0);
		result.subscribe(
			(response) => {
				this.lstPointsTransaction = response;

				//Update Values
				for (var i = 0; i < this.lstPointsTransaction.length; i++) {
					var next = this.lstPointsTransaction[i];

					next.TransactionDTDesc = moment(next.TransactionDT).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstPointsTransactionTypeDesc = Array.from(new Set(this.lstPointsTransaction.map((item: any) => item.PointsTransactionTypeDesc))).sort();
				this.lstPointsItemDesc = Array.from(new Set(this.lstPointsTransaction.map((item: any) => item.PointsItemDesc))).sort();
				this.lstIsVoidDesc = Array.from(new Set(this.lstPointsTransaction.map((item: any) => item.IsVoidDesc))).sort();
				this.lstPartOfGroupDesc = Array.from(new Set(this.lstPointsTransaction.map((item: any) => item.PartOfGroupDesc))).sort();
				this.lstGroupName = Array.from(new Set(this.lstPointsTransaction.map((item: any) => item.GroupName))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		this.loadStudentPBISData();
	}

	//Custom Button Methods
	onAddPoint() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentPBISAddComponent, {
			header: "Add Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				PersonID: this.SelectedPerson.PersonID,
				StudentID: this.SelectedPerson.DesignatorID,
				StudentName: this.SelectedPerson.PersonName,
				SchoolID: this.SelectedPerson.SchoolID,
				CurrentBalance: this.CurrentBalance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStats();
				this.loadStudentPBISData();
			}
		});
	}

	onRedeemPoint() {
		this.errorMessage = "";

		//Error handling
		if (this.CurrentBalance <= 0) {
			this.errorMessage = "No points to redeem";
			return;
		}

		var ref = this.dialogService.open(StudentPBISRedeemComponent, {
			header: "Redeem Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				PersonID: this.SelectedPerson.PersonID,
				StudentID: this.SelectedPerson.DesignatorID,
				StudentName: this.SelectedPerson.PersonName,
				SchoolID: this.SelectedPerson.SchoolID,
				CurrentBalance: this.CurrentBalance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStats();
				this.loadStudentPBISData();
			}
		});
	}

	onVoid() {
		this.errorMessage = "";

		if (this.SelectedPointsTransaction == undefined) {
			this.errorMessage = "Select a transaction to void/ignore";
			return;
		}

		if (this.SelectedPointsTransaction.IsVoid == 1) {
			this.errorMessage = "Cannot void/ignore a voided transaction";
			return;
		}

		this.confirmationService.confirm({
			key: "person",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to void/ignore this transaction?",
			header: "Confirm Void Transaction",
			icon: "fa",
			accept: () => {
				this.FinishVoid();
			},
		});
	}

	FinishVoid() {
		this.isProcessing = true;

		var result = this.PBISService.PBISPointVoid(this.SelectedPointsTransaction.PointsTransactionID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadStats();
					this.loadStudentPBISData();

					this.isProcessing = false;
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "person",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not void/ignore the transaction. NOTE: Only the last transaction that was made can be voided.",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onPrint() {
		this.errorMessage = "";

		var component = this;
		this.errorMessage = "";

		var strParam = "";
		this.isProcessing = true;

		//Insert Custom Parameters Here
		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: ShowVoid
		strParam += "," + (this.ShowVoid == true ? "1" : "0") + "|ShowVoid";

		var reportID = 428;

		//Add person selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, 1);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	onDelete() {
		this.isProcessing = true;

		var result = this.PBISService.PBISPointDelete(this.SelectedPointsTransaction.PointsTransactionID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadStats();
					this.loadStudentPBISData();

					this.isProcessing = false;
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "person",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the transaction.",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onStartDateChange(val) {
		this.errorMessage = "";

		this.StartDate = val;

		this.loadStudentPBISData();
	}

	onEndDateChange(val) {
		this.errorMessage = "";

		this.EndDate = val;

		this.loadStudentPBISData();
	}

	onVoidChange(val) {
		this.errorMessage = "";

		this.ShowVoid = val;

		this.loadStudentPBISData();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedPointsTransaction = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedPointsTransaction = null;
	}
	onRowDblClick(Transaction) {
		this.errorMessage = "";

		this.SelectedPointsTransaction = Transaction;
		// this.onRedeemPoint();
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////

	IsLoading() {
		return this.StatLoading == true || this.SelectedPerson == undefined || this.isProcessing == true || this.loading == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	/////////////////////////////////////////
}
